import { JetView } from "webix-jet";

import "../../helpers/customcheckbox";
import { checkedIcon, notCheckedIcon } from "../../helpers/icons";

export default class RulesView extends JetView {
	config() {
		const _ = this.app.getService("locale")._;
		const form = {
			view: "form",
			rows: [
				{
					rows: [
						{
							view: "template",
							localId: "title",
							borderless: true,
							height: 25,
							css: "webix_um_details_title",
							template: "#name#",
							data: { name: "" },
						},
						{
							cols: [
								{
									view: "template",
									localId: "number",
									borderless: true,
									height: 40,
									css: "webix_um_details_title_description",
									template: v => {
										const number = v.rules ? v.rules.length : 0;
										let descr = !number
											? _("No rules")
											: `${_("Rules assigned")} (${number})`;
										return `<div class="webix_um_details_title_description">${descr}</div>`;
									},
									data: { name: "" },
								},
								{
									rows: [
										{
											view: "toggle",
											localId: "toggle",
											offLabel: _("Modify"),
											onLabel: _("Done"),
											width: 160,
											on: {
												onChange: v => this.ToggleVisible(v),
											},
										},
										{},
									],
								},
							],
						},
					],
				},
			],
		};

		const table = {
			view: "datatable",
			localId: "rules",
			rowHeight: webix.skin.$active.rowHeight > 30 ? 60 : 52,
			rowLineHeight: 28,
			css: "webix_um_details_table webix_um_details_table_rules",
			columns: [
				{
					id: "selected",
					hidden: true,
					header: { content: "umMasterCheckox", contentId: "ch" },
					width: 45,
					css: "webix_um_checkbox_column",
					cssFormat: (_, obj) => (obj.selected ? "webix_um_row_select" : ""),
					template: obj => {
						return obj.selected ? checkedIcon : notCheckedIcon;
					},
				},
				{
					id: "name",
					header: {
						content: "textFilter",
						compare: this.GetCompare(),
						prepare: a => a.toLowerCase(),
						placeholder: _("Search"),
					},
					fillspace: 2,
					cssFormat: (_, obj) => (obj.selected ? "webix_um_row_select" : ""),
					template: function(obj) {
						return (
							obj.short + `<div class='webix_um_details_row'>${obj.long}</div>`
						);
					},
				},
			],
			on: {
				onItemClick: id => this.Toggle(id.row * 1),
				onCustomSave: () => this.Save(),
			},
		};

		return {
			type: "clean",
			rows: [
				{
					rows: [form, table],
				},
			],
		};
	}

	urlChange() {
		this.ID = this.getParam("id", true);
		if (this.ID) this.GetData();
	}

	GetData() {
		const local = this.app.getService("local");
		this.ShowAll = false;

		this.$$("rules").registerFilter(
			this.$$("toggle"),
			{
				compare(_v1, _v2, obj) {
					return obj.selected;
				},
			},
			{
				getValue: a => (a.getValue() ? "" : true),
			}
		);

		return Promise.all([local.roles(), local.rules()]).then(data => {
			this.Role = webix.copy(data[0].getItem(this.ID));
			this.Role.rules = this.Role.rules || [];

			const rules = data[1].serialize().map(({ id, short, long }) => ({
				id,
				short,
				long,
				selected: this.Role.rules.indexOf(id) !== -1,
			}));
			this.$$("rules").parse(rules);
			this.$$("title").setValues(this.Role);
			this.ShowNumber();
			this.Filter();
		});
	}

	Save() {
		this.Role.rules = [];
		this.$$("rules").data.each(
			a => {
				if (a.selected) this.Role.rules.push(a.id);
			},
			this,
			true
		);
		this.ShowNumber();
		this.app.getService("operations").updateRole(this.Role.id, this.Role);
	}

	ShowNumber() {
		this.$$("number").setValues(this.Role);
	}

	ToggleVisible() {
		this.ShowAll = !this.ShowAll;

		if (this.ShowAll) this.$$("rules").showColumn("selected");
		else this.$$("rules").hideColumn("selected");

		this.Filter();
	}

	Toggle(id) {
		if (!this.ShowAll) return;
		const item = this.$$("rules").getItem(id);
		this.$$("rules").updateItem(id, { selected: !item.selected });
		this.Save();
	}

	Filter() {
		this.$$("rules").filterByAll();
		this.$$("rules").sort((a, b) =>
			a.selected == b.selected
				? a.short > b.short
					? 1
					: -1
				: a.selected
				? -1
				: 1
		);
	}

	// shows rows with short and long rule data in filtering results
	GetCompare() {
		return (value, searchValue, rule) => {
			return (
				rule.short.toLowerCase().indexOf(searchValue) > -1 ||
				rule.long.toLowerCase().indexOf(searchValue) > -1
			);
		};
	}
}
